var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#272B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 16.5C31 7.93959 24.0604 1 15.5 1C6.93959 1 0 7.93959 0 16.5C0 25.0604 6.93959 32 15.5 32C24.0604 32 31 25.0604 31 16.5Z",
    stroke: "white",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5609 17.0679C26.465 18.6338 25.9284 20.636 24.3626 21.54L20.4367 23.8066C18.8708 24.7107 16.8686 24.1742 15.9646 22.6084C15.0605 21.0425 15.597 19.0402 17.1629 18.1362L21.0887 15.8696C22.6546 14.9655 24.6568 15.502 25.5609 17.0679Z",
    fill: "#49CC68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2712 9.63747C22.1753 11.2033 21.6388 13.2056 20.0729 14.1096L10.9113 19.3991C9.34546 20.3032 7.34321 19.7667 6.43916 18.2008C5.53511 16.6349 6.07162 14.6327 7.63747 13.7286L16.7991 8.43916C18.365 7.53511 20.3672 8.07161 21.2712 9.63747Z",
    fill: "#49CC68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopper);
export default __webpack_public_path__ + "static/media/topper.97980cacba4d5d9cc36cb4c4760658c4.svg";
export { ForwardRef as ReactComponent };